export default function getRewardfulReferral() {
  if (typeof window === 'undefined') return;

  if (window.Rewardful && window.Rewardful.tracked) {
    return window.Rewardful.referral;
  }

  return;
}
